import { isObject } from 'lodash-es'

import { ZAirbridgeObject, type TAirbridgeObject } from '@/shared/api'

export const extractAirbridgeObject = (
  envelope: unknown,
): TAirbridgeObject | undefined => {
  if (!isObject(envelope)) return undefined

  const candidate = (envelope as { airbridgeObject?: unknown }).airbridgeObject

  if (!candidate) return undefined

  const parsed = ZAirbridgeObject.safeParse(candidate)

  return parsed.success ? parsed.data : undefined
}
